import { Directive, effect, HostBinding, inject, Input, signal } from '@angular/core';
import { BreakpointService } from '../services/breakpoint.service';

@Directive({
    selector: '[bigSharedScrollMargin]',
})
export class ScrollMarginDirective {
    public static readonly defaultOffset = 32;

    private readonly breakpointService = inject(BreakpointService);
    private readonly _settings = signal<{ offset?: number }>({});

    @HostBinding('style.scroll-margin.px')
    public scrollMargin!: number;

    @Input('bigSharedScrollMargin')
    public set settings(settings: { offset?: number }) {
        this._settings.set(settings);
    }

    public constructor() {
        effect(() => {
            const offset = this._settings().offset ?? ScrollMarginDirective.defaultOffset;

            this.scrollMargin = offset + this.breakpointService.topBarSize().height + this.breakpointService.headerSize().height;
        })
    }
}
